<template xmlns="http://www.w3.org/1999/html">
  <div style="width: 100%; height: 100%;">
    <div style="width: 100%; height: 50px; line-height: 50px; font-weight: bold; font-size: 18px;">
      ECOMMERCE PRODUCT <span v-if="item.id === 0">NEW</span><span></span>
    </div>
    <div style="width: 100%; height: calc(100% - 50px); display: flex;">
      <div style="width: 50%; height: 100%; overflow-y: scroll;">
        <div class="container text-left input-form-container">
          <div class="row">
            <div class="col-12">
              Product Title
              <input class="form-control" v-model="item.title"></input>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              Category
              <select class="form-control" v-model="item.categoryId">
                <option value="0">Select category</option>
                <option v-for="c in categories" v-bind:key="'cat-selection-item-' + c.id" :value="c.id">{{c.title}}</option>
              </select>
            </div>
            <div class="col-6">
              Business Type
              <select class="form-control" v-model="item.businessTypeId">
                <option value="0">Select Business Type</option>
                <option v-for="b in businesses" v-bind:key="'business-selection-item-' + b.id" :value="b.id">{{b.title}}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              NET
              <input type="number" v-model="item.netFloat" class="form-control" @change="onPriceChanged"/>
            </div>
            <div class="col-4">
              VAT
              <select class="form-control" v-model="item.vatRate" @change="onPriceChanged">
                <option value="0">Zero Rate</option>
                <option value="2000">20% Standard Rate</option>
              </select>
            </div>
            <div class="col-4">
              Gross
              <label class="form-control">{{(item.gross/100.0).toFixed(2)}}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              Size
              <input class="form-control" v-model="item.size"/>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              Number of Units
              <input type="number" class="form-control" v-model="item.units"/>
            </div>

          </div>

          <div class="row">
            <div class="col-4">
              Available From
              <input type="date" class="form-control" v-model="item.availableFromDate"/>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              Main Image
            </div>
            <div class="col-12">
              <div class="item-main-image-container" v-if="item.mainImage !== null && item.mainImage.length > 0" v-bind:style="{backgroundImage : 'url(' + item.mainImage + ')'}">

              </div>
              <progress value="0" max="100" id="main-image-uploader-add"></progress>
              <input accept="image/*" type="file" ref="file-main-image" value="upload" @change="photoPicked($event, 'mainImage', 'main-image-uploader-add', false)" data-buttonText="Select Photo">

              <input type="text" v-model="item.mainImage" class="form-control"/>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              Images
            </div>
          </div>

          <div class="row">
            <div class="col-12" style="display: inline-block;">
              <draggable v-model="item.images" :options="{animation: 300}" :group="item.images"  @start="drag=true" @end="drag=false">
              <template v-for="(image, ii) in item.images">


                  <div class="item-image-container"  v-bind:style="{backgroundImage : 'url(' + image + ')'}">
                    <div class="top-right-icon" @click="item.images.splice(ii, 1)"><span><i class="fas fa-trash"></i></span></div>
                    <div class="top-left-icon" @click="setToMain(ii)"><span>To Main</span></div>
                  </div>




              </template>
              </draggable>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <progress value="0" max="100" id="images-uploader"></progress>
              <input accept="image/*" type="file" ref="file-image" value="upload" @change="photoPicked($event, 'images', 'images-uploader', true)" data-buttonText="Select Photo"/>
            </div>

          </div>
          <div class="row">
            <div class="col-12">
              Description
              <textarea class="form-control" v-model="item.description" rows="10"/>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <b>Product Status</b><br/>
              <button class="btn" :class="{'btn-success': item.active === true}" @click="item.active = true">Active</button>
              <button class="btn" :class="{'btn-danger': item.active === false}" @click="item.active = false">Inactive</button>
            </div>
          </div>
          <div class="row" style="margin-bottom: 30px;">
            <div class="col-4">
              <button class="btn btn-dark form-control" @click="closeView">CLOSE</button>
            </div>
            <div class="col-4">

            </div>
            <div class="col-4">
              <button class="btn btn-primary form-control" @click="updateItem"><span v-if="item.id === 0">CREATE</span><span v-else>UPDATE</span></button>
            </div>
          </div>
        </div>
      </div>
      <div style="width: 50%; height: 100%; overflow-y: scroll; text-align: left; padding: 10px;">
        <template v-if="item.mainProduct !== null">
          <h2>KOKORO PRODUCT info</h2>
          <h3>Product Title: {{item.mainProduct.title}}</h3>
          <h3>Primary Cost: {{(item.mainProduct.sourcePrice/100.0).toFixed(2)}}</h3>
          <h3>Product VAT: {{(item.mainProduct.taxRate/100.0).toFixed(2)}}%</h3>
          <h3>Status </h3>

        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {updateComProduct} from "../../api/ecomApi";
import {showDialog} from "../../api/utils";
import firebase from "firebase";
import EventBus from "../../api/event-bus";
import draggable from "vuedraggable";
export default {
  name: "EcomProductItemView",
  props: {
    item: {
      type:Object,
      default: function() {return null;}
    },
    categories: {
      type:Array,
      default: function() {return [];}
    },
    businesses:{
      type:Array,
      default: function() {return [];}
    },
    onUpdated: {
      type: Function,
      default: null,
    },
    onClose: {
      type: Function,
      default: null,
    }
  },
  components: {
    draggable
  },
  data() {
    return {

    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    closeView: function() {
      if(this.onClose !== null) {
        this.onClose();
      }
    },
    onPriceChanged: function() {
      this.item.net = Math.round(this.item.netFloat*100);
      if(this.item.vatRate === 0) {
        this.item.vat = 0;
      } else {
        this.item.vat = Math.round(this.item.netFloat * this.item.vatRate/10000 * 100);
      }
      this.item.gross = this.item.net + this.item.vat;

    },
    updateItem: function() {
      let self = this;
      console.log("update item");
      console.log(this.item);
      updateComProduct(this.item)
        .then(function(data) {
          if(data.success === true) {
            if(self.onUpdated !== null) {
              self.onUpdated(data.item);
            }
            if(self.onClose !== null) {
              self.onClose();
            }
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          console.log(err);
          if(err.response !== undefined) {
            console.log(err.response);
          }
        })
    },
    photoPicked: function(e, field, progressBarId, isList = false) {
      const uploader = document.getElementById(progressBarId);
      console.log(e);
      let getFile = e.target.files[0];
      console.log("File name - " + getFile.name);
      //set storage ref
      let d = new Date();
      let name  = d.getTime();
      let names = getFile.name.split('.');

      let path = 'shop/product/'+ this.item.id + '/' +  name + '.' + names[names.length-1];
      let storageRef = firebase.storage().ref();
      let mountainsRef = storageRef.child(path);
      let self = this;
      EventBus.$emit("showLoading", true);
      mountainsRef.put(getFile).on('state_changed',
        function progress(snapshot){

          let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) *100;
          console.log("percentage " + percentage);
          uploader.value = percentage;
        },
        function error(err){
          // EventBus.$emit("showLoading", false);
          EventBus.$emit("showLoading", false);
          console.log(err);
        },
        function complete(){
          EventBus.$emit("showLoading", false);
          console.log('complete upload');
          // self.$data.editGoodItem.imageUrl = 'https://storage.googleapis.com/uko-projects.appspot.com/' + path;
          // self.updateEditGoodItem();

          setTimeout(function() {

            self.onPhotoUploaded('https://storage.googleapis.com/kokoro-294123.appspot.com/' + path, field, isList);
          }, 2000);
        }
      );
    },
    onPhotoUploaded: function(url, field, isList) {
      if(isList) {
        this.item[field].push(url);
      } else {
        this.item[field] = url;
      }

    },
    setToMain: function(index) {
      let targetImage = this.item.images[index];
      let mainInage = this.item.mainImage;

      this.item.images.splice(index, 1, mainInage);
      this.item.mainImage = targetImage;
    }
  }
}
</script>

<style scoped>
.item-main-image-container {
  width: 200px;
  height: 200px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid #ECECEC;
}
.item-image-container {
  float: left;
  width: 200px;
  height: 200px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid #ECECEC;
  position: relative;
}
.top-right-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  line-height: 20px;
  height: 20px;
  width: 20px;
  font-size: 15px;
  background-color: red;
  color:white;
  font-weight: bold;
  text-align: center;
}
.top-left-icon {
  position: absolute;
  top: 10px;
  left: 10px;
  line-height: 20px;
  font-size: 10px;
  padding: 5px;
  background-color: green;
  color:white;
  font-weight: bold;
  text-align: center;
}
.input-form-container .row {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/ItemView/EcomProductItemView.vue